import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelToken = null;

class NotificationService {
  getNotificationStatus({ id, notificationType }) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.post(`${Config.api.notification.url}events/status`, {
      id,
      notificationType,
    }).then((response) => response.data);
  }

  getEvents({ page = 1, pageSize = 10, since } = {}) {
    const params = { isCleared: false, page, pageSize };
    // The API expects 'since' as epoch milliseconds (e.g. 1755594857250); the store keeps ISO createdAt strings.
    if (since) params.since = new Date(since).getTime();

    return ApiService.get(`${Config.api.notification.url}events`, { params }).then((response) => response.data);
  }

  getEventsCount() {
    return ApiService.get(`${Config.api.notification.url}events/count`, {
      params: { isCleared: false },
    }).then((response) => response.data);
  }

  getUnreadCount() {
    return ApiService.get(`${Config.api.notification.url}events/unread-count`).then((response) => response.data);
  }

  markAsRead(id) {
    return ApiService.put(`${Config.api.notification.url}events/${id}/read`, { isRead: true }).then(
      (response) => response.data,
    );
  }

  markAllAsRead() {
    return ApiService.put(`${Config.api.notification.url}events/read-all`).then((response) => response.data);
  }
}

const notificationService = new NotificationService();

export default notificationService;
